import React, { Component } from "react";
import {
  Card, CardBody, Row, Col, Table, Button, Input,
  FormGroup, Label, Alert, Badge, CustomInput,
} from "reactstrap";
import AiAdminLayout from "./layout";
import { fetchApi, postApi, deleteApi, uploadApi } from "./api";

class AiAdminKnowledge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: [],
      shops: [],
      selectedShop: "",
      loading: true,
      // Upload form
      inputMode: "file",
      file: null,
      title: "",
      description: "",
      textContent: "",
      uploadShopId: "",
      uploading: false,
      message: "",
      messageType: "success",
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    try {
      const documents = await fetchApi(
        `/knowledge${this.state.selectedShop ? `?shop_id=${this.state.selectedShop}` : ""}`,
      );
      this.setState({ documents: Array.isArray(documents) ? documents : [], loading: false });
    } catch (err) {
      console.error("Knowledge load error:", err);
      this.setState({ documents: [], loading: false });
    }
    // Load shops separately so failure doesn't block document list
    try {
      const shops = await fetchApi("/stats/shops");
      if (Array.isArray(shops)) this.setState({ shops });
    } catch (err) {
      console.error("Shops load error:", err);
    }
  };

  handleFilterShop = async (shopId) => {
    this.setState({ selectedShop: shopId, loading: true }, async () => {
      try {
        const documents = await fetchApi(
          `/knowledge${shopId ? `?shop_id=${shopId}` : ""}`,
        );
        this.setState({ documents: Array.isArray(documents) ? documents : [], loading: false });
      } catch (err) {
        console.error("Filter error:", err);
        this.setState({ documents: [], loading: false });
      }
    });
  };

  handleUpload = async () => {
    const { inputMode, file, title, description, textContent } = this.state;

    this.setState({ uploading: true, message: "" });
    try {
      if (inputMode === "file") {
        if (!file) {
          this.setState({ message: "Please select a file", messageType: "danger", uploading: false });
          return;
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("shop_id", this.state.uploadShopId || "0");
        if (title) formData.append("title", title);
        if (description) formData.append("description", description);
        await uploadApi("/knowledge/upload", formData);
      } else {
        if (!textContent.trim()) {
          this.setState({ message: "Content cannot be empty", messageType: "danger", uploading: false });
          return;
        }
        await postApi("/knowledge/text", {
          content: textContent,
          title: title || "Note",
          description,
          shop_id: this.state.uploadShopId || "0",
        });
      }

      this.setState({
        message: "Upload successful!",
        messageType: "success",
        file: null,
        title: "",
        description: "",
        textContent: "",
        uploading: false,
      });
      this.loadData();
    } catch (err) {
      this.setState({
        message: err.response?.data?.error || "Upload failed",
        messageType: "danger",
        uploading: false,
      });
    }
  };

  handleDelete = async (documentId, shopId) => {
    if (!window.confirm("Delete this document and all its chunks?")) return;
    try {
      await deleteApi(`/knowledge/${documentId}?shop_id=${shopId}`);
      this.setState({ message: "Document deleted", messageType: "success" });
      this.loadData();
    } catch (err) {
      this.setState({
        message: err.response?.data?.error || "Delete failed",
        messageType: "danger",
      });
    }
  };

  render() {
    const {
      documents, shops, selectedShop, loading,
      inputMode, file, title, description, textContent,
      uploading, message, messageType,
    } = this.state;

    // Unique shop IDs from shops list
    const shopOptions = shops.map((s) => s.shop_id).filter(Boolean);

    return (
      <AiAdminLayout>
        <h4 className="font-weight-bold mb-4">Knowledge Base</h4>

        <Row>
          {/* Upload Form */}
          <Col lg={4}>
            <Card style={{ borderRadius: 8 }}>
              <CardBody>
                <h6 className="font-weight-bold mb-3">Add Knowledge</h6>

                {message && (
                  <Alert color={messageType} className="py-2" style={{ fontSize: 13 }}>
                    {message}
                  </Alert>
                )}

                <FormGroup>
                  <Label style={{ fontSize: 13 }}>Shop</Label>
                  <Input
                    type="select"
                    bsSize="sm"
                    value={this.state.uploadShopId}
                    onChange={(e) => this.setState({ uploadShopId: e.target.value })}
                  >
                    <option value="">Global (shop_id=0)</option>
                    {shopOptions.map((id) => (
                      <option key={id} value={id}>Shop #{id}</option>
                    ))}
                  </Input>
                </FormGroup>

                <FormGroup>
                  <Label style={{ fontSize: 13 }}>Input Type</Label>
                  <div>
                    <CustomInput
                      type="radio"
                      id="mode-file"
                      name="inputMode"
                      label="File Upload"
                      checked={inputMode === "file"}
                      onChange={() => this.setState({ inputMode: "file" })}
                      inline
                    />
                    <CustomInput
                      type="radio"
                      id="mode-text"
                      name="inputMode"
                      label="Text Input"
                      checked={inputMode === "text"}
                      onChange={() => this.setState({ inputMode: "text" })}
                      inline
                    />
                  </div>
                </FormGroup>

                {inputMode === "file" ? (
                  <FormGroup>
                    <Label style={{ fontSize: 13 }}>File (.txt, .pdf, .md, .csv, .docx, .xlsx)</Label>
                    <CustomInput
                      type="file"
                      id="knowledgeFile"
                      accept=".txt,.pdf,.md,.csv,.docx,.xlsx,.xls"
                      onChange={(e) => this.setState({ file: e.target.files[0] })}
                    />
                  </FormGroup>
                ) : (
                  <FormGroup>
                    <Label style={{ fontSize: 13 }}>Content</Label>
                    <Input
                      type="textarea"
                      rows={5}
                      value={textContent}
                      onChange={(e) => this.setState({ textContent: e.target.value })}
                      placeholder="Paste knowledge content here..."
                    />
                  </FormGroup>
                )}

                <FormGroup>
                  <Label style={{ fontSize: 13 }}>Title</Label>
                  <Input
                    bsSize="sm"
                    value={title}
                    onChange={(e) => this.setState({ title: e.target.value })}
                    placeholder="Document title"
                  />
                </FormGroup>

                <FormGroup>
                  <Label style={{ fontSize: 13 }}>Description (optional)</Label>
                  <Input
                    bsSize="sm"
                    value={description}
                    onChange={(e) => this.setState({ description: e.target.value })}
                    placeholder="Brief description"
                  />
                </FormGroup>

                <Button
                  color="primary"
                  block
                  size="sm"
                  onClick={this.handleUpload}
                  disabled={uploading}
                >
                  {uploading ? "Uploading..." : "Upload"}
                </Button>
              </CardBody>
            </Card>
          </Col>

          {/* Document List */}
          <Col lg={8}>
            <Card style={{ borderRadius: 8 }}>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="font-weight-bold mb-0">Documents</h6>
                  <Input
                    type="select"
                    bsSize="sm"
                    style={{ width: 180 }}
                    value={selectedShop}
                    onChange={(e) => this.handleFilterShop(e.target.value)}
                  >
                    <option value="">All Shops</option>
                    {shopOptions.map((id) => (
                      <option key={id} value={id}>Shop #{id}</option>
                    ))}
                  </Input>
                </div>

                {loading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border spinner-border-sm text-primary" />
                  </div>
                ) : documents.length === 0 ? (
                  <p className="text-muted text-center py-4">No documents found</p>
                ) : (
                  <Table responsive size="sm" style={{ fontSize: 13 }}>
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Shop</th>
                        <th>Chunks</th>
                        <th>Created</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {documents.map((doc, i) => (
                        <tr key={i}>
                          <td>
                            <strong>{doc.title || doc.filename || "Untitled"}</strong>
                            {doc.filename && (
                              <div className="text-muted" style={{ fontSize: 11 }}>
                                {doc.filename}
                              </div>
                            )}
                          </td>
                          <td>
                            <Badge color="light" className="text-dark">
                              #{doc.shop_id}
                            </Badge>
                          </td>
                          <td>{doc.chunk_count}</td>
                          <td style={{ fontSize: 11 }}>
                            {doc.created_at
                              ? new Date(doc.created_at).toLocaleDateString("vi-VN")
                              : "—"}
                          </td>
                          <td>
                            <Button
                              color="link"
                              size="sm"
                              className="text-danger p-0"
                              onClick={() => this.handleDelete(doc.document_id, doc.shop_id)}
                            >
                              <i className="simple-icon-trash" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </AiAdminLayout>
    );
  }
}

export default AiAdminKnowledge;
